export enum InvestTypes {
  GET_ALL_INVESTMENTS_CALL = 'GET_ALL_INVESTMENTS_CALL',
  GET_ALL_INVESTMENTS_LOADING = 'GET_USER_INVESTMENTS_CALL_LOADING',
  GET_ALL_INVESTMENTS_SUCCESS = 'GET_ALL_INVESTMENTS_SUCCESS',

  GET_USER_INVESTMENTS_CALL = 'GET_USER_INVESTMENTS_CALL',
  GET_USER_INVESTMENTS_LOADING = 'GET_USER_INVESTMENTS_CALL_LOADING',
  GET_USER_INVESTMENTS_SUCCESS = 'GET_USER_INVESTMENTS_SUCCESS',
  UPDATE_PAYMENT_PATH_FORM = 'UPDATE_PAYMENT_PATH_FORM',
  CREATE_INVESTMENT_CALL = 'CREATE_INVESTMENT_CALL',
  CREATE_INVESTMENT_LOADING = 'CREATE_INVESTMENT_LOADING',
  CREATE_INVESTMENT_SUCCESS = 'CREATE_INVESTMENT_SUCCESS',
}

export interface InvestState {
  all: []
  user: []
  investmentPath: []
  loading: boolean
}

export type Investment = {
  amount_invested: string
  can_withdraw: boolean
  id: string
  investment_date: string | Date
  investment_plan: { [key: string]: any }
  mature: boolean
  maturity_date: string | Date
  roi: string
  source: string
  status: 'active' | 'matured' | 'processing'
  withdrawn: boolean
  sold_out: boolean
}

export interface CreateInvestmentPayload {
  investment_plan_id: string
  amount: string | number
  channel: string
  card_id: string
}
